import { _8x8 } from "./_8x8/manifest";
import { abnormalSecurity } from "./abnormalSecurity/manifest";
import { absolute } from "./absolute/manifest";
import { abusech } from "./abusech/manifest";
import { abuseipdb } from "./abuseipdb/manifest";
import { accelo } from "./accelo/manifest";
import { acronis } from "./acronis/manifest";
import { action1 } from "./action1/manifest";
import { actionNetwork } from "./actionNetwork/manifest";
import { activeCampaign } from "./activeCampaign/manifest";
import { activeDirectory } from "./activeDirectory/manifest";
import { activepieces } from "./activepieces/manifest";
import { acuityScheduling } from "./acuityScheduling/manifest";
import { adalo } from "./adalo/manifest";
import { adaptiveShield } from "./adaptiveShield/manifest";
import { adGuard } from "./adGuard/manifest";
import { adminByRequest } from "./adminByRequest/manifest";
import { adobe } from "./adobe/manifest";
import { adobeCloud } from "./adobeCloud/manifest";
import { adobeCommerce } from "./adobeCommerce/manifest";
import { adobeWorkfront } from "./adobeWorkfront/manifest";
import { adp } from "./adp/manifest";
import { adyen } from "./adyen/manifest";
import { affinityV2 } from "./affinityV2/manifest";
import { agariBrandProtection } from "./agariBrandProtection/manifest";
import { agariPhishingDefense } from "./agariPhishingDefense/manifest";
import { agariPhishingResponse } from "./agariPhishingResponse/manifest";
import { agentforce } from "./agentforce/manifest";
import { ahrefs } from "./ahrefs/manifest";
import { aikido } from "./aikido/manifest";
import { airbase } from "./airbase/manifest";
import { airbyte } from "./airbyte/manifest";
import { aircall } from "./aircall/manifest";
import { airlock } from "./airlock/manifest";
import { airlockDigital } from "./airlockDigital/manifest";
import { airtable } from "./airtable/manifest";
import { airtop } from "./airtop/manifest";
import { akamai } from "./akamai/manifest";
import { akamaiIdentityCloudSocial } from "./akamaiIdentityCloudSocial/manifest";
import { akeyless } from "./akeyless/manifest";
import { alchemy } from "./alchemy/manifest";
import { alertLogic } from "./alertLogic/manifest";
import { alertmedia } from "./alertmedia/manifest";
import { algolia } from "./algolia/manifest";
import { algosecFirewallAnalyzer } from "./algosecFirewallAnalyzer/manifest";
import { alienvaultOtx } from "./alienvaultOtx/manifest";
import { alienvaultUsm } from "./alienvaultUsm/manifest";
import { alpaca } from "./alpaca/manifest";
import { alphaVantage } from "./alphaVantage/manifest";
import { amazonSellerCentral } from "./amazonSellerCentral/manifest";
import { amplitude } from "./amplitude/manifest";
import { analyst1 } from "./analyst1/manifest";
import { anodot } from "./anodot/manifest";
import { anomaliThreatStream } from "./anomaliThreatStream/manifest";
import { ansible } from "./ansible/manifest";
import { anthropic } from "./anthropic/manifest";
import { anvilogic } from "./anvilogic/manifest";
import { anyRun } from "./anyRun/manifest";
import { apacheAirflow } from "./apacheAirflow/manifest";
import { apexOne } from "./apexOne/manifest";
import { apify } from "./apify/manifest";
import { apiKey } from "./apiKey/manifest";
import { apiTemplateIo } from "./apiTemplateIo/manifest";
import { apero } from "./apero/manifest";
import { apivoid } from "./apivoid/manifest";
import { apollo } from "./apollo/manifest";
import { apolloIo } from "./apolloIo/manifest";
import { appDynamics } from "./appDynamics/manifest";
import { appleBusinessManager } from "./appleBusinessManager/manifest";
import { appwrite } from "./appwrite/manifest";
import { aquaSecurity } from "./aquaSecurity/manifest";
import { arcsightEsm } from "./arcsightEsm/manifest";
import { arcticWolf } from "./arcticWolf/manifest";
import { ardoq } from "./ardoq/manifest";
import { argocd } from "./argocd/manifest";
import { argoWorkflows } from "./argoWorkflows/manifest";
import { aristaCloudVision } from "./aristaCloudVision/manifest";
import { armis } from "./armis/manifest";
import { asana } from "./asana/manifest";
import { ashby } from "./ashby/manifest";
import { assemblyAi } from "./assemblyAi/manifest";
import { astrix } from "./astrix/manifest";
import { atera } from "./atera/manifest";
import { atlassianAdmin } from "./atlassianAdmin/manifest";
import { attentive } from "./attentive/manifest";
import { attio } from "./attio/manifest";
import { audiobookshelf } from "./audiobookshelf/manifest";
import { auth0 } from "./auth0/manifest";
import { authelia } from "./authelia/manifest";
import { authentik } from "./authentik/manifest";
import { autodesk } from "./autodesk/manifest";
import { automox } from "./automox/manifest";
import { autopilot } from "./autopilot/manifest";
import { autotask } from "./autotask/manifest";
import { auvik } from "./auvik/manifest";
import { avalara } from "./avalara/manifest";
import { awardWallet } from "./awardWallet/manifest";
import { aws } from "./aws/manifest";
import { awsBedrock } from "./awsBedrock/manifest";
import { awsEks } from "./awsEks/manifest";
import { awsRdsMysql } from "./awsRdsMysql/manifest";
import { awsRdsPostgres } from "./awsRdsPostgres/manifest";
import { axiom } from "./axiom/manifest";
import { axonius } from "./axonius/manifest";
import { azureDevOps } from "./azureDevOps/manifest";
import { azureOpenai } from "./azureOpenai/manifest";
import { backblazeB2 } from "./backblazeB2/manifest";
import { bamboo } from "./bamboo/manifest";
import { bambooHr } from "./bambooHr/manifest";
import { basecamp } from "./basecamp/manifest";
import { baserow } from "./baserow/manifest";
import { beehiiv } from "./beehiiv/manifest";
import { betterStack } from "./betterStack/manifest";
import { beyondTrust } from "./beyondTrust/manifest";
import { bigCommerce } from "./bigCommerce/manifest";
import { bigPanda } from "./bigPanda/manifest";
import { billCom } from "./billCom/manifest";
import { bingWebmasters } from "./bingWebmasters/manifest";
import { bird } from "./bird/manifest";
import { bitbucket } from "./bitbucket/manifest";
import { bitdefender } from "./bitdefender/manifest";
import { bitly } from "./bitly/manifest";
import { bitwarden } from "./bitwarden/manifest";
import { blackKite } from "./blackKite/manifest";
import { bloodhound } from "./bloodhound/manifest";
import { blueCat } from "./blueCat/manifest";
import { bluesky } from "./bluesky/manifest";
import { bond } from "./bond/manifest";
import { bmcHelix } from "./bmcHelix/manifest";
import { bookingCom } from "./bookingCom/manifest";
import { bookStack } from "./bookStack/manifest";
import { box } from "./box/manifest";
import { braintree } from "./braintree/manifest";
import { braintrust } from "./braintrust/manifest";
import { brandfetch } from "./brandfetch/manifest";
import { braveSearch } from "./braveSearch/manifest";
import { braze } from "./braze/manifest";
import { brevo } from "./brevo/manifest";
import { brex } from "./brex/manifest";
import { browserless } from "./browserless/manifest";
import { bubble } from "./bubble/manifest";
import { budibase } from "./budibase/manifest";
import { bugcrowd } from "./bugcrowd/manifest";
import { bugsnag } from "./bugsnag/manifest";
import { buildium } from "./buildium/manifest";
import { buildkite } from "./buildkite/manifest";
import { builtWith } from "./builtWith/manifest";
import { bullhorn } from "./bullhorn/manifest";
import { calCom } from "./calCom/manifest";
import { calendly } from "./calendly/manifest";
import { callrail } from "./callrail/manifest";
import { canny } from "./canny/manifest";
import { canva } from "./canva/manifest";
import { canvasLms } from "./canvasLms/manifest";
import { capeSandbox } from "./capeSandbox/manifest";
import { carbonBlack } from "./carbonBlack/manifest";
import { castle } from "./castle/manifest";
import { census } from "./census/manifest";
import { censys } from "./censys/manifest";
import { cerebras } from "./cerebras/manifest";
import { chainguard } from "./chainguard/manifest";
import { changedetection } from "./changedetection/manifest";
import { chargebee } from "./chargebee/manifest";
import { chartHop } from "./chartHop/manifest";
import { chatwoot } from "./chatwoot/manifest";
import { checkly } from "./checkly/manifest";
import { checkmarx } from "./checkmarx/manifest";
import { checkmk } from "./checkmk/manifest";
import { checkoutCom } from "./checkoutCom/manifest";
import { checkPoint } from "./checkPoint/manifest";
import { chorus } from "./chorus/manifest";
import { chroma } from "./chroma/manifest";
import { chronosphere } from "./chronosphere/manifest";
import { circleci } from "./circleci/manifest";
import { circleSo } from "./circleSo/manifest";
import { ciscoCdets } from "./ciscoCdets/manifest";
import { ciscoFtdv } from "./ciscoFtdv/manifest";
import { ciscoOrbital } from "./ciscoOrbital/manifest";
import { ciscoSecureCloudAnalytics } from "./ciscoSecureCloudAnalytics/manifest";
import { ciscoSecureFirewall } from "./ciscoSecureFirewall/manifest";
import { ciscoThousandEyes } from "./ciscoThousandEyes/manifest";
import { ciscoThreatGrid } from "./ciscoThreatGrid/manifest";
import { ciscoUmbrella } from "./ciscoUmbrella/manifest";
import { ciscoXdr } from "./ciscoXdr/manifest";
import { clarotyXdome } from "./clarotyXdome/manifest";
import { clay } from "./clay/manifest";
import { clearbit } from "./clearbit/manifest";
import { clerk } from "./clerk/manifest";
import { clickhouse } from "./clickhouse/manifest";
import { clicksend } from "./clicksend/manifest";
import { clickUp } from "./clickUp/manifest";
import { clio } from "./clio/manifest";
import { clockify } from "./clockify/manifest";
import { close } from "./close/manifest";
import { cloudbeds } from "./cloudbeds/manifest";
import { cloudflare } from "./cloudflare/manifest";
import { cloudinary } from "./cloudinary/manifest";
import { cloudtalk } from "./cloudtalk/manifest";
import { clover } from "./clover/manifest";
import { clutchSecurity } from "./clutchSecurity/manifest";
import { cockpit } from "./cockpit/manifest";
import { coda } from "./coda/manifest";
import { codacy } from "./codacy/manifest";
import { code42 } from "./code42/manifest";
import { codecov } from "./codecov/manifest";
import { coder } from "./coder/manifest";
import { cofenseTriage } from "./cofenseTriage/manifest";
import { cohere } from "./cohere/manifest";
import { coinGecko } from "./coinGecko/manifest";
import { coinMarketCap } from "./coinMarketCap/manifest";
import { commercetools } from "./commercetools/manifest";
import { companycam } from "./companycam/manifest";
import { conductorOne } from "./conductorOne/manifest";
import { confluence } from "./confluence/manifest";
import { confluent } from "./confluent/manifest";
import { connectWise } from "./connectWise/manifest";
import { connectwisePsa } from "./connectwisePsa/manifest";
import { connectwiseRmm } from "./connectwiseRmm/manifest";
import { constantContact } from "./constantContact/manifest";
import { contabo } from "./contabo/manifest";
import { contentful } from "./contentful/manifest";
import { contentstack } from "./contentstack/manifest";
import { convertKit } from "./convertKit/manifest";
import { conveyor } from "./conveyor/manifest";
import { copper } from "./copper/manifest";
import { coralogix } from "./coralogix/manifest";
import { coreLogic } from "./coreLogic/manifest";
import { cornerstone } from "./cornerstone/manifest";
import { cortex } from "./cortex/manifest";
import { cortexXdr } from "./cortexXdr/manifest";
import { cortexXsoar } from "./cortexXsoar/manifest";
import { couchDb } from "./couchDb/manifest";
import { coupa } from "./coupa/manifest";
import { courier } from "./courier/manifest";
import { cribl } from "./cribl/manifest";
import { criminalIp } from "./criminalIp/manifest";
import { crisp } from "./crisp/manifest";
import { crowdin } from "./crowdin/manifest";
import { crowdSec } from "./crowdSec/manifest";
import { crowdStrike } from "./crowdStrike/manifest";
import { cultureAmp } from "./cultureAmp/manifest";
import { cursor } from "./cursor/manifest";
import { customerIo } from "./customerIo/manifest";
import { customOauth } from "./customOauth/manifest";
import { cyberArk } from "./cyberArk/manifest";
import { cybereason } from "./cybereason/manifest";
import { cyberhaven } from "./cyberhaven/manifest";
import { cycode } from "./cycode/manifest";
import { cyera } from "./cyera/manifest";
import { cywareCtix } from "./cywareCtix/manifest";
import { dagster } from "./dagster/manifest";
import { darktrace } from "./darktrace/manifest";
import { dashlane } from "./dashlane/manifest";
import { databricks } from "./databricks/manifest";
import { databricksWorkspace } from "./databricksWorkspace/manifest";
import { datadog } from "./datadog/manifest";
import { dataForSeo } from "./dataForSeo/manifest";
import { dataGolf } from "./dataGolf/manifest";
import { datoCms } from "./datoCms/manifest";
import { datto } from "./datto/manifest";
import { dattoRmm } from "./dattoRmm/manifest";
import { dayforce } from "./dayforce/manifest";
import { dbtCloud } from "./dbtCloud/manifest";
import { deel } from "./deel/manifest";
import { deepgram } from "./deepgram/manifest";
import { deepl } from "./deepl/manifest";
import { deepseek } from "./deepseek/manifest";
import { deezer } from "./deezer/manifest";
import { demio } from "./demio/manifest";
import { dependencyTrack } from "./dependencyTrack/manifest";
import { depot } from "./depot/manifest";
import { detectify } from "./detectify/manifest";
import { deutscheBahn } from "./deutscheBahn/manifest";
import { dfirIris } from "./dfirIris/manifest";
import { dhl } from "./dhl/manifest";
import { dialpad } from "./dialpad/manifest";
import { digitalGuardian } from "./digitalGuardian/manifest";
import { digitalOcean } from "./digitalOcean/manifest";
import { directus } from "./directus/manifest";
import { discord } from "./discord/manifest";
import { discourse } from "./discourse/manifest";
import { disqus } from "./disqus/manifest";
import { dixa } from "./dixa/manifest";
import { dnsFilter } from "./dnsFilter/manifest";
import { dnsimple } from "./dnsimple/manifest";
import { dnslytics } from "./dnslytics/manifest";
import { docebo } from "./docebo/manifest";
import { dockerHub } from "./dockerHub/manifest";
import { dockerRegistry } from "./dockerRegistry/manifest";
import { docSpring } from "./docSpring/manifest";
import { documenso } from "./documenso/manifest";
import { domainTools } from "./domainTools/manifest";
import { docusign } from "./docusign/manifest";
import { domo } from "./domo/manifest";
import { domoticz } from "./domoticz/manifest";
import { doppler } from "./doppler/manifest";
import { dragosWorldview } from "./dragosWorldview/manifest";
import { drata } from "./drata/manifest";
import { dremio } from "./dremio/manifest";
import { drift } from "./drift/manifest";
import { drip } from "./drip/manifest";
import { dropbox } from "./dropbox/manifest";
import { dropboxSign } from "./dropboxSign/manifest";
import { dropcontact } from "./dropcontact/manifest";
import { dub } from "./dub/manifest";
import { duffel } from "./duffel/manifest";
import { duo } from "./duo/manifest";
import { dynamics365 } from "./dynamics365/manifest";
import { dynatrace } from "./dynatrace/manifest";
import { easyPost } from "./easyPost/manifest";
import { ebay } from "./ebay/manifest";
import { edlManager } from "./edlManager/manifest";
import { egnyte } from "./egnyte/manifest";
import { egoi } from "./egoi/manifest";
import { elastic } from "./elastic/manifest";
import { elevenLabs } from "./elevenLabs/manifest";
import { emailrep } from "./emailrep/manifest";
import { emelia } from "./emelia/manifest";
import { entroSecurity } from "./entroSecurity/manifest";
import { envoy } from "./envoy/manifest";
import { erpNext } from "./erpNext/manifest";
import { esetProtect } from "./esetProtect/manifest";
import { espoCrm } from "./espoCrm/manifest";
import { etherscan } from "./etherscan/manifest";
import { etsy } from "./etsy/manifest";
import { eventbrite } from "./eventbrite/manifest";
import { everhour } from "./everhour/manifest";
import { exa } from "./exa/manifest";
import { exabeam } from "./exabeam/manifest";
import { exactOnline } from "./exactOnline/manifest";
import { expel } from "./expel/manifest";
import { expensify } from "./expensify/manifest";
import { f5BigIp } from "./f5BigIp/manifest";
import { f5DistributedCloudServices } from "./f5DistributedCloudServices/manifest";
import { facebook } from "./facebook/manifest";
import { facebookMessenger } from "./facebookMessenger/manifest";
import { factorial } from "./factorial/manifest";
import { fastly } from "./fastly/manifest";
import { fastmail } from "./fastmail/manifest";
import { fathomAnalytics } from "./fathomAnalytics/manifest";
import { feedly } from "./feedly/manifest";
import { fifteenFive } from "./fifteenFive/manifest";
import { figma } from "./figma/manifest";
import { filescan } from "./filescan/manifest";
import { fillout } from "./fillout/manifest";
import { firebase } from "./firebase/manifest";
import { firecrawl } from "./firecrawl/manifest";
import { fireHydrant } from "./fireHydrant/manifest";
import { fireworksAi } from "./fireworksAi/manifest";
import { fitbit } from "./fitbit/manifest";
import { fivetran } from "./fivetran/manifest";
import { fleetDm } from "./fleetDm/manifest";
import { flightAware } from "./flightAware/manifest";
import { flightradar24 } from "./flightradar24/manifest";
import { float } from "./float/manifest";
import { flow } from "./flow/manifest";
import { flowise } from "./flowise/manifest";
import { flyIo } from "./flyIo/manifest";
import { forgejo } from "./forgejo/manifest";
import { formbricks } from "./formbricks/manifest";
import { formstack } from "./formstack/manifest";
import { fortinet } from "./fortinet/manifest";
import { fortnox } from "./fortnox/manifest";
import { fred } from "./fred/manifest";
import { freeagent } from "./freeagent/manifest";
import { freshbooks } from "./freshbooks/manifest";
import { freshdesk } from "./freshdesk/manifest";
import { freshRss } from "./freshRss/manifest";
import { freshService } from "./freshService/manifest";
import { freshsales } from "./freshsales/manifest";
import { front } from "./front/manifest";
import { fullHunt } from "./fullHunt/manifest";
import { fullStory } from "./fullStory/manifest";
import { fusionAuth } from "./fusionAuth/manifest";
import { gainsight } from "./gainsight/manifest";
import { gandi } from "./gandi/manifest";
import { garmin } from "./garmin/manifest";
import { gem } from "./gem/manifest";
import { genesys } from "./genesys/manifest";
import { ghost } from "./ghost/manifest";
import { giphy } from "./giphy/manifest";
import { gitbook } from "./gitbook/manifest";
import { gitea } from "./gitea/manifest";
import { gitguardian } from "./gitguardian/manifest";
import { github } from "./github/manifest";
import { gitlab } from "./gitlab/manifest";
import { gitpod } from "./gitpod/manifest";
import { gladly } from "./gladly/manifest";
import { glean } from "./glean/manifest";
import { glpi } from "./glpi/manifest";
import { gmail } from "./gmail/manifest";
import { gmailSmtp } from "./gmailSmtp/manifest";
import { godaddy } from "./godaddy/manifest";
import { gong } from "./gong/manifest";
import { googleAdminConsole } from "./googleAdminConsole/manifest";
import { googleAnalytics } from "./googleAnalytics/manifest";
import { googleCalendar } from "./googleCalendar/manifest";
import { googleChat } from "./googleChat/manifest";
import { googleCloud } from "./googleCloud/manifest";
import { googleDocs } from "./googleDocs/manifest";
import { googleDrive } from "./googleDrive/manifest";
import { googleGemini } from "./googleGemini/manifest";
import { googleMaps } from "./googleMaps/manifest";
import { googlePlay } from "./googlePlay/manifest";
import { googleSearchConsole } from "./googleSearchConsole/manifest";
import { googleSheets } from "./googleSheets/manifest";
import { gorgias } from "./gorgias/manifest";
import { gotify } from "./gotify/manifest";
import { gotosocial } from "./gotosocial/manifest";
import { govee } from "./govee/manifest";
import { grafana } from "./grafana/manifest";
import { graylog } from "./graylog/manifest";
import { greenhouse } from "./greenhouse/manifest";
import { greynoise } from "./greynoise/manifest";
import { gripSecurity } from "./gripSecurity/manifest";
import { grist } from "./grist/manifest";
import { grok } from "./grok/manifest";
import { groq } from "./groq/manifest";
import { growthBook } from "./growthBook/manifest";
import { gumroad } from "./gumroad/manifest";
import { guru } from "./guru/manifest";
import { gusto } from "./gusto/manifest";
import { habitica } from "./habitica/manifest";
import { hackerOne } from "./hackerOne/manifest";
import { haloPsa } from "./haloPsa/manifest";
import { harbor } from "./harbor/manifest";
import { harness } from "./harness/manifest";
import { harvest } from "./harvest/manifest";
import { hashicorpConsul } from "./hashicorpConsul/manifest";
import { hashicorpNomad } from "./hashicorpNomad/manifest";
import { hashicorpVault } from "./hashicorpVault/manifest";
import { hasura } from "./hasura/manifest";
import { hatchingTriage } from "./hatchingTriage/manifest";
import { headscale } from "./headscale/manifest";
import { healthchecks } from "./healthchecks/manifest";
import { heap } from "./heap/manifest";
import { helpScout } from "./helpScout/manifest";
import { heroku } from "./heroku/manifest";
import { hetzner } from "./hetzner/manifest";
import { heygen } from "./heygen/manifest";
import { hiBob } from "./hiBob/manifest";
import { hibp } from "./hibp/manifest";
import { highLevel } from "./highLevel/manifest";
import { hightouch } from "./hightouch/manifest";
import { homeAssistant } from "./homeAssistant/manifest";
import { honeybadger } from "./honeybadger/manifest";
import { honeycomb } from "./honeycomb/manifest";
import { hostIo } from "./hostIo/manifest";
import { hotjar } from "./hotjar/manifest";
import { htmlCssToImage } from "./htmlCssToImage/manifest";
import { hubitat } from "./hubitat/manifest";
import { hubSpot } from "./hubSpot/manifest";
import { huggingFace } from "./huggingFace/manifest";
import { humanticAi } from "./humanticAi/manifest";
import { humio } from "./humio/manifest";
import { hunterIo } from "./hunterIo/manifest";
import { hunters } from "./hunters/manifest";
import { huntIo } from "./huntIo/manifest";
import { huntress } from "./huntress/manifest";
import { hybridAnalysis } from "./hybridAnalysis/manifest";
import { hyperproof } from "./hyperproof/manifest";
import { ibmCloud } from "./ibmCloud/manifest";
import { ibmQradar } from "./ibmQradar/manifest";
import { ibmXForceExchange } from "./ibmXForceExchange/manifest";
import { icims } from "./icims/manifest";
import { idMe } from "./idMe/manifest";
import { ileDeFranceMobilites } from "./ileDeFranceMobilites/manifest";
import { imap } from "./imap/manifest";
import { imapXoauth2 } from "./imapXoauth2/manifest";
import { immersiveLabs } from "./immersiveLabs/manifest";
import { immich } from "./immich/manifest";
import { impervaWaf } from "./impervaWaf/manifest";
import { incidentIo } from "./incidentIo/manifest";
import { infisical } from "./infisical/manifest";
import { influxdb } from "./influxdb/manifest";
import { infoblox } from "./infoblox/manifest";
import { infobloxBloxone } from "./infobloxBloxone/manifest";
import { instagram } from "./instagram/manifest";
import { instatus } from "./instatus/manifest";
import { intelOwl } from "./intelOwl/manifest";
import { intercom } from "./intercom/manifest";
import { intezer } from "./intezer/manifest";
import { intuit } from "./intuit/manifest";
import { invicti } from "./invicti/manifest";
import { invoiceNinja } from "./invoiceNinja/manifest";
import { ionos } from "./ionos/manifest";
import { ip2location } from "./ip2location/manifest";
import { ipApi } from "./ipApi/manifest";
import { ipInfo } from "./ipInfo/manifest";
import { ipify } from "./ipify/manifest";
import { ipQualityScore } from "./ipQualityScore/manifest";
import { ipstack } from "./ipstack/manifest";
import { ironclad } from "./ironclad/manifest";
import { island } from "./island/manifest";
import { iterable } from "./iterable/manifest";
import { ivanti } from "./ivanti/manifest";
import { jamf } from "./jamf/manifest";
import { jazzHr } from "./jazzHr/manifest";
import { jeli } from "./jeli/manifest";
import { jellyfin } from "./jellyfin/manifest";
import { jellyfish } from "./jellyfish/manifest";
import { jenkins } from "./jenkins/manifest";
import { jfrogArtifactory } from "./jfrogArtifactory/manifest";
import { jinaAi } from "./jinaAi/manifest";
import { jira } from "./jira/manifest";
import { jiraDataCenter } from "./jiraDataCenter/manifest";
import { jiraServiceManagement } from "./jiraServiceManagement/manifest";
import { jobvite } from "./jobvite/manifest";
import { joeSandbox } from "./joeSandbox/manifest";
import { jotForm } from "./jotForm/manifest";
import { jumpCloud } from "./jumpCloud/manifest";
import { juniperMist } from "./juniperMist/manifest";
import { jupiterOne } from "./jupiterOne/manifest";
import { kakaoTalk } from "./kakaoTalk/manifest";
import { kandji } from "./kandji/manifest";
import { kavita } from "./kavita/manifest";
import { kayako } from "./kayako/manifest";
import { keap } from "./keap/manifest";
import { kentik } from "./kentik/manifest";
import { kestra } from "./kestra/manifest";
import { keycloak } from "./keycloak/manifest";
import { kibana } from "./kibana/manifest";
import { kimai } from "./kimai/manifest";
import { kintone } from "./kintone/manifest";
import { klaviyo } from "./klaviyo/manifest";
import { knock } from "./knock/manifest";
import { knowBe4 } from "./knowBe4/manifest";
import { koBoToolbox } from "./koBoToolbox/manifest";
import { kolide } from "./kolide/manifest";
import { komga } from "./komga/manifest";
import { kronos } from "./kronos/manifest";
import { kubernetes } from "./kubernetes/manifest";
import { kustomer } from "./kustomer/manifest";
import { lacework } from "./lacework/manifest";
import { langfuse } from "./langfuse/manifest";
import { langsmith } from "./langsmith/manifest";
import { lansweeper } from "./lansweeper/manifest";
import { lark } from "./lark/manifest";
import { lastpass } from "./lastpass/manifest";
import { lattice } from "./lattice/manifest";
import { launchDarkly } from "./launchDarkly/manifest";
import { ldap } from "./ldap/manifest";
import { leantime } from "./leantime/manifest";
import { leapsome } from "./leapsome/manifest";
import { learnUpon } from "./learnUpon/manifest";
import { lemlist } from "./lemlist/manifest";
import { lemmy } from "./lemmy/manifest";
import { lemonSqueezy } from "./lemonSqueezy/manifest";
import { lever } from "./lever/manifest";
import { lifx } from "./lifx/manifest";
import { limaCharlie } from "./limaCharlie/manifest";
import { line } from "./line/manifest";
import { linear } from "./linear/manifest";
import { linkding } from "./linkding/manifest";
import { linkedIn } from "./linkedIn/manifest";
import { linode } from "./linode/manifest";
import { listmonk } from "./listmonk/manifest";
import { liteLlm } from "./liteLlm/manifest";
import { lob } from "./lob/manifest";
import { loginCredentials } from "./loginCredentials/manifest";
import { logPoint } from "./logPoint/manifest";
import { logScale } from "./logScale/manifest";
import { logto } from "./logto/manifest";
import { logzIo } from "./logzIo/manifest";
import { loneScale } from "./loneScale/manifest";
import { looker } from "./looker/manifest";
import { loom } from "./loom/manifest";
import { loops } from "./loops/manifest";
import { lucidChart } from "./lucidChart/manifest";
import { luma } from "./luma/manifest";
import { lumos } from "./lumos/manifest";
import { magento } from "./magento/manifest";
import { mailcheck } from "./mailcheck/manifest";
import { mailchimp } from "./mailchimp/manifest";
import { mailerLite } from "./mailerLite/manifest";
import { mailgun } from "./mailgun/manifest";
import { mailjet } from "./mailjet/manifest";
import { make } from "./make/manifest";
import { malShare } from "./malShare/manifest";
import { malwarebytes } from "./malwarebytes/manifest";
import { manageEngine } from "./manageEngine/manifest";
import { mapbox } from "./mapbox/manifest";
import { marketoEngage } from "./marketoEngage/manifest";
import { marketstack } from "./marketstack/manifest";
import { massive } from "./massive/manifest";
import { mastodon } from "./mastodon/manifest";
import { materialSecurity } from "./materialSecurity/manifest";
import { matomo } from "./matomo/manifest";
import { matrixSynapse } from "./matrixSynapse/manifest";
import { mattermost } from "./mattermost/manifest";
import { mautic } from "./mautic/manifest";
import { maxMind } from "./maxMind/manifest";
import { mealie } from "./mealie/manifest";
import { medallia } from "./medallia/manifest";
import { medium } from "./medium/manifest";
import { medusaJs } from "./medusaJs/manifest";
import { meilisearch } from "./meilisearch/manifest";
import { mend } from "./mend/manifest";
import { meraki } from "./meraki/manifest";
import { mercury } from "./mercury/manifest";
import { messageBird } from "./messageBird/manifest";
import { metabase } from "./metabase/manifest";
import { microsoftAzure } from "./microsoftAzure/manifest";
import { microsoftBusinessCentral } from "./microsoftBusinessCentral/manifest";
import { microsoftDefenderForEndpoint } from "./microsoftDefenderForEndpoint/manifest";
import { microsoftFoundry } from "./microsoftFoundry/manifest";
import { microsoftGraph } from "./microsoftGraph/manifest";
import { microsoftGraphDelegated } from "./microsoftGraphDelegated/manifest";
import { microsoftIntune } from "./microsoftIntune/manifest";
import { microsoftOneDrive } from "./microsoftOneDrive/manifest";
import { microsoftOutlook } from "./microsoftOutlook/manifest";
import { microsoftSentinel } from "./microsoftSentinel/manifest";
import { microsoftTeams } from "./microsoftTeams/manifest";
import { mimecast } from "./mimecast/manifest";
import { mindee } from "./mindee/manifest";
import { miniflux } from "./miniflux/manifest";
import { minio } from "./minio/manifest";
import { miro } from "./miro/manifest";
import { misp } from "./misp/manifest";
import { misskey } from "./misskey/manifest";
import { mistralAi } from "./mistralAi/manifest";
import { mitre } from "./mitre/manifest";
import { mixpanel } from "./mixpanel/manifest";
import { modeAnalytics } from "./modeAnalytics/manifest";
import { modernTreasury } from "./modernTreasury/manifest";
import { modrinth } from "./modrinth/manifest";
import { mollie } from "./mollie/manifest";
import { mondayDotCom } from "./mondayDotCom/manifest";
import { mongodb } from "./mongodb/manifest";
import { mongodbAtlas } from "./mongodbAtlas/manifest";
import { mssql } from "./mssql/manifest";
import { mux } from "./mux/manifest";
import { mysql } from "./mysql/manifest";
import { mosyle } from "./mosyle/manifest";
import { msg91 } from "./msg91/manifest";
import { mural } from "./mural/manifest";
import { mxToolBox } from "./mxToolBox/manifest";
import { n8n } from "./n8n/manifest";
import { nagios } from "./nagios/manifest";
import { namecheap } from "./namecheap/manifest";
import { namely } from "./namely/manifest";
import { navan } from "./navan/manifest";
import { navidrome } from "./navidrome/manifest";
import { nederlandseSpoorwegen } from "./nederlandseSpoorwegen/manifest";
import { neo4j } from "./neo4j/manifest";
import { neonTech } from "./neonTech/manifest";
import { netbird } from "./netbird/manifest";
import { netbox } from "./netbox/manifest";
import { netdata } from "./netdata/manifest";
import { netlas } from "./netlas/manifest";
import { netlify } from "./netlify/manifest";
import { netography } from "./netography/manifest";
import { netSuite } from "./netSuite/manifest";
import { netscalerAdc } from "./netscalerAdc/manifest";
import { netskope } from "./netskope/manifest";
import { newRelic } from "./newRelic/manifest";
import { newsApi } from "./newsApi/manifest";
import { nextcloud } from "./nextcloud/manifest";
import { nextDns } from "./nextDns/manifest";
import { ninjaone } from "./ninjaone/manifest";
import { nirvana } from "./nirvana/manifest";
import { nocodb } from "./nocodb/manifest";
import { notion } from "./notion/manifest";
import { npm } from "./npm/manifest";
import { ntfy } from "./ntfy/manifest";
import { nuclino } from "./nuclino/manifest";
import { nudgeSecurity } from "./nudgeSecurity/manifest";
import { numeral } from "./numeral/manifest";
import { nutanixPrism } from "./nutanixPrism/manifest";
import { nvidiaNgc } from "./nvidiaNgc/manifest";
import { ocrSpace } from "./ocrSpace/manifest";
import { octopusDeploy } from "./octopusDeploy/manifest";
import { odoo } from "./odoo/manifest";
import { okta } from "./okta/manifest";
import { ollama } from "./ollama/manifest";
import { oneLogin } from "./oneLogin/manifest";
import { onePassword } from "./onePassword/manifest";
import { onePasswordConnectServer } from "./onePasswordConnectServer/manifest";
import { onePasswordUsers } from "./onePasswordUsers/manifest";
import { oneSignal } from "./oneSignal/manifest";
import { oneSimpleApi } from "./oneSimpleApi/manifest";
import { oneTrust } from "./oneTrust/manifest";
import { onetimeSecret } from "./onetimeSecret/manifest";
import { oneuptime } from "./oneuptime/manifest";
import { onfleet } from "./onfleet/manifest";
import { onyphe } from "./onyphe/manifest";
import { oomnitza } from "./oomnitza/manifest";
import { opal } from "./opal/manifest";
import { openai } from "./openai/manifest";
import { openaiCompatible } from "./openaiCompatible/manifest";
import { openCti } from "./openCti/manifest";
import { opencage } from "./opencage/manifest";
import { openHab } from "./openHab/manifest";
import { openproject } from "./openproject/manifest";
import { openRouter } from "./openRouter/manifest";
import { opensearch } from "./opensearch/manifest";
import { openWeatherMap } from "./openWeatherMap/manifest";
import { opnsense } from "./opnsense/manifest";
import { opsGenie } from "./opsGenie/manifest";
import { oracleCloudHcm } from "./oracleCloudHcm/manifest";
import { oracleIam } from "./oracleIam/manifest";
import { oracleJdEdwards } from "./oracleJdEdwards/manifest";
import { oracleOci } from "./oracleOci/manifest";
import { oraclePeopleSoft } from "./oraclePeopleSoft/manifest";
import { orbit } from "./orbit/manifest";
import { orcaSecurity } from "./orcaSecurity/manifest";
import { oura } from "./oura/manifest";
import { outline } from "./outline/manifest";
import { outreach } from "./outreach/manifest";
import { ovh } from "./ovh/manifest";
import { paddle } from "./paddle/manifest";
import { pagerDuty } from "./pagerDuty/manifest";
import { paloAltoPanOs } from "./paloAltoPanOs/manifest";
import { pandaDoc } from "./pandaDoc/manifest";
import { panOs } from "./panOs/manifest";
import { panther } from "./panther/manifest";
import { panWildfire } from "./panWildfire/manifest";
import { paperlessNgx } from "./paperlessNgx/manifest";
import { parallel } from "./parallel/manifest";
import { particle } from "./particle/manifest";
import { pastebin } from "./pastebin/manifest";
import { patreon } from "./patreon/manifest";
import { paychex } from "./paychex/manifest";
import { paycom } from "./paycom/manifest";
import { paycor } from "./paycor/manifest";
import { payloadCms } from "./payloadCms/manifest";
import { paylocity } from "./paylocity/manifest";
import { paypal } from "./paypal/manifest";
import { pdfCo } from "./pdfCo/manifest";
import { pdfGenerator } from "./pdfGenerator/manifest";
import { peertube } from "./peertube/manifest";
import { pendo } from "./pendo/manifest";
import { penpot } from "./penpot/manifest";
import { pentera } from "./pentera/manifest";
import { perplexity } from "./perplexity/manifest";
import { personio } from "./personio/manifest";
import { phishStats } from "./phishStats/manifest";
import { phylum } from "./phylum/manifest";
import { pinecone } from "./pinecone/manifest";
import { pingdom } from "./pingdom/manifest";
import { pingIdentity } from "./pingIdentity/manifest";
import { pinterest } from "./pinterest/manifest";
import { pipedrive } from "./pipedrive/manifest";
import { pixelfed } from "./pixelfed/manifest";
import { plaid } from "./plaid/manifest";
import { plain } from "./plain/manifest";
import { plane } from "./plane/manifest";
import { planetscale } from "./planetscale/manifest";
import { planhat } from "./planhat/manifest";
import { planka } from "./planka/manifest";
import { plausible } from "./plausible/manifest";
import { pleo } from "./pleo/manifest";
import { plex } from "./plex/manifest";
import { plexTrac } from "./plexTrac/manifest";
import { plivo } from "./plivo/manifest";
import { pocketbase } from "./pocketbase/manifest";
import { podium } from "./podium/manifest";
import { portainer } from "./portainer/manifest";
import { postHog } from "./postHog/manifest";
import { postgres } from "./postgres/manifest";
import { postman } from "./postman/manifest";
import { postmark } from "./postmark/manifest";
import { powerBi } from "./powerBi/manifest";
import { prefect } from "./prefect/manifest";
import { printful } from "./printful/manifest";
import { prismaCloud } from "./prismaCloud/manifest";
import { procore } from "./procore/manifest";
import { productboard } from "./productboard/manifest";
import { productiv } from "./productiv/manifest";
import { profitWell } from "./profitWell/manifest";
import { projectDiscovery } from "./projectDiscovery/manifest";
import { prometheus } from "./prometheus/manifest";
import { proofpoint } from "./proofpoint/manifest";
import { proofpointProtectionServer } from "./proofpointProtectionServer/manifest";
import { proofpointThreatResponse } from "./proofpointThreatResponse/manifest";
import { proxmox } from "./proxmox/manifest";
import { prtg } from "./prtg/manifest";
import { pulsedive } from "./pulsedive/manifest";
import { pulumi } from "./pulumi/manifest";
import { pushover } from "./pushover/manifest";
import { pylon } from "./pylon/manifest";
import { qdrant } from "./qdrant/manifest";
import { qlik } from "./qlik/manifest";
import { qualtrics } from "./qualtrics/manifest";
import { qualys } from "./qualys/manifest";
import { quickbase } from "./quickbase/manifest";
import { quickbooks } from "./quickbooks/manifest";
import { quickChart } from "./quickChart/manifest";
import { rabbitmq } from "./rabbitmq/manifest";
import { railDataMarketplace } from "./railDataMarketplace/manifest";
import { railway } from "./railway/manifest";
import { ramp } from "./ramp/manifest";
import { rancher } from "./rancher/manifest";
import { rapid7 } from "./rapid7/manifest";
import { rawg } from "./rawg/manifest";
import { razorpay } from "./razorpay/manifest";
import { recharge } from "./recharge/manifest";
import { recordedFuture } from "./recordedFuture/manifest";
import { reddit } from "./reddit/manifest";
import { redisCloud } from "./redisCloud/manifest";
import { redmine } from "./redmine/manifest";
import { reftab } from "./reftab/manifest";
import { regscale } from "./regscale/manifest";
import { remoteMcp } from "./remoteMcp/manifest";
import { render } from "./render/manifest";
import { replicate } from "./replicate/manifest";
import { resend } from "./resend/manifest";
import { retool } from "./retool/manifest";
import { ringCentral } from "./ringCentral/manifest";
import { rippling } from "./rippling/manifest";
import { rocketChat } from "./rocketChat/manifest";
import { rollbar } from "./rollbar/manifest";
import { rootly } from "./rootly/manifest";
import { rudderStack } from "./rudderStack/manifest";
import { rundeck } from "./rundeck/manifest";
import { runZero } from "./runZero/manifest";
import { sage } from "./sage/manifest";
import { sailPoint } from "./sailPoint/manifest";
import { salesforce } from "./salesforce/manifest";
import { salesloft } from "./salesloft/manifest";
import { sanity } from "./sanity/manifest";
import { sapConcur } from "./sapConcur/manifest";
import { sapSuccessFactors } from "./sapSuccessFactors/manifest";
import { scaleway } from "./scaleway/manifest";
import { screenshotMachine } from "./screenshotMachine/manifest";
import { seafile } from "./seafile/manifest";
import { seaTable } from "./seaTable/manifest";
import { secretServer } from "./secretServer/manifest";
import { secureAnnex } from "./secureAnnex/manifest";
import { secureframe } from "./secureframe/manifest";
import { securityScorecard } from "./securityScorecard/manifest";
import { securityTrails } from "./securityTrails/manifest";
import { segment } from "./segment/manifest";
import { sekoia } from "./sekoia/manifest";
import { semaphore } from "./semaphore/manifest";
import { semgrep } from "./semgrep/manifest";
import { sendGrid } from "./sendGrid/manifest";
import { sentinelOne } from "./sentinelOne/manifest";
import { sentry } from "./sentry/manifest";
import { serpApi } from "./serpApi/manifest";
import { serviceNow } from "./serviceNow/manifest";
import { sharePoint } from "./sharePoint/manifest";
import { shelly } from "./shelly/manifest";
import { shippo } from "./shippo/manifest";
import { shipstationV2 } from "./shipstationV2/manifest";
import { shlink } from "./shlink/manifest";
import { shodan } from "./shodan/manifest";
import { shopify } from "./shopify/manifest";
import { shortcut } from "./shortcut/manifest";
import { shuffler } from "./shuffler/manifest";
import { signnow } from "./signnow/manifest";
import { signoz } from "./signoz/manifest";
import { silentPush } from "./silentPush/manifest";
import { sisense } from "./sisense/manifest";
import { site24x7 } from "./site24x7/manifest";
import { slab } from "./slab/manifest";
import { slack } from "./slack/manifest";
import { slashid } from "./slashid/manifest";
import { smartsheet } from "./smartsheet/manifest";
import { smartThings } from "./smartThings/manifest";
import { smtp } from "./smtp/manifest";
import { sms77 } from "./sms77/manifest";
import { smugmug } from "./smugmug/manifest";
import { snapchat } from "./snapchat/manifest";
import { sncf } from "./sncf/manifest";
import { snipeIt } from "./snipeIt/manifest";
import { snowflake } from "./snowflake/manifest";
import { snyk } from "./snyk/manifest";
import { socket } from "./socket/manifest";
import { solarWinds } from "./solarWinds/manifest";
import { solarWindsServiceDesk } from "./solarWindsServiceDesk/manifest";
import { sonarCloud } from "./sonarCloud/manifest";
import { sonarQube } from "./sonarQube/manifest";
import { sonarr } from "./sonarr/manifest";
import { sonatype } from "./sonatype/manifest";
import { sophos } from "./sophos/manifest";
import { sophosUtm } from "./sophosUtm/manifest";
import { sourcegraph } from "./sourcegraph/manifest";
import { sourcehut } from "./sourcehut/manifest";
import { spacelift } from "./spacelift/manifest";
import { sparkPost } from "./sparkPost/manifest";
import { split } from "./split/manifest";
import { splitwise } from "./splitwise/manifest";
import { splunk } from "./splunk/manifest";
import { spotify } from "./spotify/manifest";
import { spur } from "./spur/manifest";
import { spyCloud } from "./spyCloud/manifest";
import { square } from "./square/manifest";
import { squarespace } from "./squarespace/manifest";
import { squareup } from "./squareup/manifest";
import { squidex } from "./squidex/manifest";
import { sslMate } from "./sslMate/manifest";
import { stabilityAi } from "./stabilityAi/manifest";
import { stackexchange } from "./stackexchange/manifest";
import { stairwell } from "./stairwell/manifest";
import { statsig } from "./statsig/manifest";
import { statuspage } from "./statuspage/manifest";
import { steam } from "./steam/manifest";
import { stitchData } from "./stitchData/manifest";
import { storyblok } from "./storyblok/manifest";
import { strapi } from "./strapi/manifest";
import { strava } from "./strava/manifest";
import { stripe } from "./stripe/manifest";
import { sublimeSecurity } from "./sublimeSecurity/manifest";
import { sugarCrm } from "./sugarCrm/manifest";
import { sumoLogic } from "./sumoLogic/manifest";
import { supabase } from "./supabase/manifest";
import { surveymonkey } from "./surveymonkey/manifest";
import { swaggerHub } from "./swaggerHub/manifest";
import { swedavia } from "./swedavia/manifest";
import { symantecEndpointSecurity } from "./symantecEndpointSecurity/manifest";
import { synack } from "./synack/manifest";
import { syncthing } from "./syncthing/manifest";
import { sysAid } from "./sysAid/manifest";
import { sysdig } from "./sysdig/manifest";
import { tableau } from "./tableau/manifest";
import { taiga } from "./taiga/manifest";
import { tailscale } from "./tailscale/manifest";
import { tally } from "./tally/manifest";
import { tandoorRecipes } from "./tandoorRecipes/manifest";
import { tanium } from "./tanium/manifest";
import { tapfiliate } from "./tapfiliate/manifest";
import { tavily } from "./tavily/manifest";
import { taxjar } from "./taxjar/manifest";
import { teamCymruScout } from "./teamCymruScout/manifest";
import { teamcity } from "./teamcity/manifest";
import { teamtailor } from "./teamtailor/manifest";
import { teamwork } from "./teamwork/manifest";
import { telegram } from "./telegram/manifest";
import { telnyx } from "./telnyx/manifest";
import { tenable } from "./tenable/manifest";
import { terraformCloud } from "./terraformCloud/manifest";
import { theHive } from "./theHive/manifest";
import { thinkstCanary } from "./thinkstCanary/manifest";
import { threatconnect } from "./threatconnect/manifest";
import { threatExchange } from "./threatExchange/manifest";
import { threeB } from "./threeB/manifest";
import { threeCx } from "./threeCx/manifest";
import { ticktick } from "./ticktick/manifest";
import { tiktok } from "./tiktok/manifest";
import { timely } from "./timely/manifest";
import { tines } from "./tines/manifest";
import { tipalti } from "./tipalti/manifest";
import { todoist } from "./todoist/manifest";
import { togetherAi } from "./togetherAi/manifest";
import { toggl } from "./toggl/manifest";
import { tolgee } from "./tolgee/manifest";
import { tooljet } from "./tooljet/manifest";
import { topdesk } from "./topdesk/manifest";
import { traceableAi } from "./traceableAi/manifest";
import { transcend } from "./transcend/manifest";
import { transportForIreland } from "./transportForIreland/manifest";
import { transportForLondon } from "./transportForLondon/manifest";
import { travelPerk } from "./travelPerk/manifest";
import { travisCi } from "./travisCi/manifest";
import { traxo } from "./traxo/manifest";
import { trellix } from "./trellix/manifest";
import { trello } from "./trello/manifest";
import { tremendous } from "./tremendous/manifest";
import { trendMicro } from "./trendMicro/manifest";
import { trendVisionOne } from "./trendVisionOne/manifest";
import { tumblr } from "./tumblr/manifest";
import { twilio } from "./twilio/manifest";
import { twingate } from "./twingate/manifest";
import { twitch } from "./twitch/manifest";
import { typeform } from "./typeform/manifest";
import type { ConnectorDefinition, ConnectorType } from "./types";
import { typesense } from "./typesense/manifest";
import { uber } from "./uber/manifest";
import { ukg } from "./ukg/manifest";
import { ultimateSoftware } from "./ultimateSoftware/manifest";
import { umami } from "./umami/manifest";
import { unpacme } from "./unpacme/manifest";
import { unsplash } from "./unsplash/manifest";
import { upcloud } from "./upcloud/manifest";
import { upguard } from "./upguard/manifest";
import { upstash } from "./upstash/manifest";
import { uptimerobot } from "./uptimerobot/manifest";
import { uptycs } from "./uptycs/manifest";
import { upwind } from "./upwind/manifest";
import { upwork } from "./upwork/manifest";
import { urlscan } from "./urlscan/manifest";
import { vanta } from "./vanta/manifest";
import { varonis } from "./varonis/manifest";
import { vectraAi } from "./vectraAi/manifest";
import { veeam } from "./veeam/manifest";
import { venafi } from "./venafi/manifest";
import { vercel } from "./vercel/manifest";
import { veza } from "./veza/manifest";
import { vikunja } from "./vikunja/manifest";
import { vimeo } from "./vimeo/manifest";
import { virusTotal } from "./virusTotal/manifest";
import { vmray } from "./vmray/manifest";
import { vmwareVSphere } from "./vmwareVSphere/manifest";
import { vonage } from "./vonage/manifest";
import { voyageAi } from "./voyageAi/manifest";
import { vuldb } from "./vuldb/manifest";
import { vulncheck } from "./vulncheck/manifest";
import { vultr } from "./vultr/manifest";
import { wakatime } from "./wakatime/manifest";
import { wallabag } from "./wallabag/manifest";
import { waveAccounting } from "./waveAccounting/manifest";
import { wazuh } from "./wazuh/manifest";
import { weaviate } from "./weaviate/manifest";
import { webex } from "./webex/manifest";
import { webflow } from "./webflow/manifest";
import { webinarjam } from "./webinarjam/manifest";
import { weightsAndBiases } from "./weightsAndBiases/manifest";
import { whatsapp } from "./whatsapp/manifest";
import { whoisFreaks } from "./whoisFreaks/manifest";
import { whoop } from "./whoop/manifest";
import { wigle } from "./wigle/manifest";
import { wikijs } from "./wikijs/manifest";
import { windmill } from "./windmill/manifest";
import { wise } from "./wise/manifest";
import { wiz } from "./wiz/manifest";
import { woocommerce } from "./woocommerce/manifest";
import { woodpeckerCi } from "./woodpeckerCi/manifest";
import { wordpress } from "./wordpress/manifest";
import { workable } from "./workable/manifest";
import { workday } from "./workday/manifest";
import { workflowApp } from "./workflowApp/manifest";
import { workplace } from "./workplace/manifest";
import { workRamp } from "./workRamp/manifest";
import { wrike } from "./wrike/manifest";
import { wufoo } from "./wufoo/manifest";
import { x } from "./x/manifest";
import { xbow } from "./xbow/manifest";
import { xero } from "./xero/manifest";
import { xMatters } from "./xMatters/manifest";
import { yahoo } from "./yahoo/manifest";
import { yelp } from "./yelp/manifest";
import { ynab } from "./ynab/manifest";
import { yourls } from "./yourls/manifest";
import { youtube } from "./youtube/manifest";
import { zabbix } from "./zabbix/manifest";
import { zammad } from "./zammad/manifest";
import { zapier } from "./zapier/manifest";
import { zendesk } from "./zendesk/manifest";
import { zendeskSell } from "./zendeskSell/manifest";
import { zenefits } from "./zenefits/manifest";
import { zeplin } from "./zeplin/manifest";
import { zeroFox } from "./zeroFox/manifest";
import { zitadel } from "./zitadel/manifest";
import { zohoCrm } from "./zohoCrm/manifest";
import { zohoDesk } from "./zohoDesk/manifest";
import { zoom } from "./zoom/manifest";
import { zoomInfo } from "./zoomInfo/manifest";
import { zscaler } from "./zscaler/manifest";
import { zulip } from "./zulip/manifest";
import { zuora } from "./zuora/manifest";

export const connectorTypes = [
  _8x8,
  abnormalSecurity,
  absolute,
  abusech,
  abuseipdb,
  accelo,
  acronis,
  activeCampaign,
  activeDirectory,
  adaptiveShield,
  adGuard,
  adminByRequest,
  adobe,
  adobeCloud,
  adobeCommerce,
  adobeWorkfront,
  adp,
  adyen,
  affinityV2,
  agariBrandProtection,
  agariPhishingDefense,
  agariPhishingResponse,
  agentforce,
  ahrefs,
  aikido,
  airbase,
  airbyte,
  aircall,
  airlock,
  airlockDigital,
  airtable,
  akamai,
  akamaiIdentityCloudSocial,
  akeyless,
  alchemy,
  alertLogic,
  alertmedia,
  algolia,
  algosecFirewallAnalyzer,
  alienvaultOtx,
  alienvaultUsm,
  alpaca,
  alphaVantage,
  amazonSellerCentral,
  amplitude,
  analyst1,
  anodot,
  anomaliThreatStream,
  ansible,
  anthropic,
  anvilogic,
  anyRun,
  apexOne,
  apero,
  appleBusinessManager,
  apify,
  apiKey,
  apivoid,
  apollo,
  apolloIo,
  appDynamics,
  appwrite,
  aquaSecurity,
  arcsightEsm,
  arcticWolf,
  ardoq,
  argocd,
  argoWorkflows,
  aristaCloudVision,
  armis,
  asana,
  ashby,
  assemblyAi,
  astrix,
  atera,
  atlassianAdmin,
  attentive,
  attio,
  auth0,
  authentik,
  authelia,
  autodesk,
  automox,
  autotask,
  auvik,
  avalara,
  awardWallet,
  aws,
  awsBedrock,
  awsEks,
  awsRdsMysql,
  awsRdsPostgres,
  axiom,
  axonius,
  azureDevOps,
  azureOpenai,
  backblazeB2,
  bamboo,
  bambooHr,
  basecamp,
  baserow,
  beehiiv,
  betterStack,
  beyondTrust,
  bigCommerce,
  bigPanda,
  billCom,
  bingWebmasters,
  bird,
  bitdefender,
  bitbucket,
  bitly,
  blackKite,
  bloodhound,
  blueCat,
  bmcHelix,
  bond,
  bookingCom,
  box,
  braintree,
  braintrust,
  braveSearch,
  braze,
  brevo,
  brex,
  browserless,
  bugcrowd,
  bugsnag,
  buildkite,
  builtWith,
  bullhorn,
  calCom,
  calendly,
  callrail,
  canny,
  canva,
  canvasLms,
  carbonBlack,
  census,
  censys,
  cerebras,
  chainguard,
  chargebee,
  chartHop,
  checkly,
  checkmarx,
  checkmk,
  checkoutCom,
  checkPoint,
  chorus,
  chronosphere,
  circleci,
  circleSo,
  ciscoCdets,
  ciscoFtdv,
  ciscoOrbital,
  ciscoSecureCloudAnalytics,
  ciscoSecureFirewall,
  ciscoThousandEyes,
  ciscoThreatGrid,
  ciscoUmbrella,
  ciscoXdr,
  clarotyXdome,
  clay,
  clerk,
  clicksend,
  clickUp,
  clio,
  clockify,
  close,
  cloudbeds,
  cloudflare,
  cloudinary,
  cloudtalk,
  clover,
  clutchSecurity,
  coda,
  codacy,
  code42,
  codecov,
  cofenseTriage,
  cohere,
  coinGecko,
  coinMarketCap,
  commercetools,
  companycam,
  conductorOne,
  confluence,
  connectWise,
  connectwisePsa,
  connectwiseRmm,
  constantContact,
  contentful,
  contentstack,
  convertKit,
  conveyor,
  copper,
  coralogix,
  coreLogic,
  cornerstone,
  cortex,
  cortexXdr,
  cortexXsoar,
  coupa,
  courier,
  cribl,
  criminalIp,
  crisp,
  crowdSec,
  crowdStrike,
  cultureAmp,
  cursor,
  customOauth,
  customerIo,
  cyberArk,
  cybereason,
  cyberhaven,
  cycode,
  cyera,
  cywareCtix,
  darktrace,
  dashlane,
  databricks,
  databricksWorkspace,
  datadog,
  dataForSeo,
  dataGolf,
  datoCms,
  datto,
  dattoRmm,
  dayforce,
  dbtCloud,
  deel,
  deepgram,
  depot,
  detectify,
  deutscheBahn,
  dialpad,
  digitalGuardian,
  digitalOcean,
  discord,
  dixa,
  dnslytics,
  docebo,
  dockerHub,
  docSpring,
  docusign,
  domainTools,
  domoticz,
  domo,
  doppler,
  dragosWorldview,
  drata,
  dremio,
  drift,
  drip,
  dropbox,
  dropboxSign,
  duffel,
  duo,
  dynamics365,
  dynatrace,
  easyPost,
  ebay,
  edlManager,
  egnyte,
  elastic,
  emailrep,
  entroSecurity,
  envoy,
  etherscan,
  etsy,
  exa,
  exabeam,
  exactOnline,
  expel,
  expensify,
  f5BigIp,
  f5DistributedCloudServices,
  factorial,
  facebook,
  fastly,
  fathomAnalytics,
  feedly,
  fifteenFive,
  figma,
  fillout,
  firecrawl,
  fireHydrant,
  fireworksAi,
  fitbit,
  fivetran,
  fleetDm,
  flightAware,
  flightradar24,
  float,
  flyIo,
  fortinet,
  fortnox,
  fred,
  freeagent,
  freshdesk,
  freshsales,
  freshService,
  front,
  fullHunt,
  fullStory,
  gainsight,
  gandi,
  garmin,
  gem,
  genesys,
  giphy,
  gitea,
  gitguardian,
  github,
  gitlab,
  gitpod,
  gladly,
  glean,
  gmail,
  gmailSmtp,
  gong,
  googleCalendar,
  googleChat,
  googleCloud,
  googleDocs,
  googleDrive,
  googleGemini,
  googleMaps,
  googlePlay,
  googleSheets,
  gorgias,
  grafana,
  graylog,
  greenhouse,
  greynoise,
  gripSecurity,
  groq,
  growthBook,
  gumroad,
  guru,
  gusto,
  haloPsa,
  hackerOne,
  harbor,
  harness,
  hashicorpVault,
  heap,
  helpScout,
  heroku,
  heygen,
  hiBob,
  hibp,
  hightouch,
  homeAssistant,
  honeybadger,
  honeycomb,
  hostIo,
  hotjar,
  htmlCssToImage,
  hubitat,
  hubSpot,
  hunterIo,
  hunters,
  huntIo,
  huntress,
  hybridAnalysis,
  hyperproof,
  ibmCloud,
  ibmQradar,
  icims,
  ileDeFranceMobilites,
  imap,
  imapXoauth2,
  immersiveLabs,
  incidentIo,
  infoblox,
  infobloxBloxone,
  instatus,
  intelOwl,
  intercom,
  intezer,
  intuit,
  invicti,
  ip2location,
  ipApi,
  ipify,
  ipInfo,
  ipQualityScore,
  ipstack,
  ironclad,
  island,
  iterable,
  ivanti,
  jamf,
  jazzHr,
  jeli,
  jellyfish,
  jenkins,
  jfrogArtifactory,
  jinaAi,
  jira,
  jiraDataCenter,
  jiraServiceManagement,
  jobvite,
  joeSandbox,
  jumpCloud,
  juniperMist,
  jupiterOne,
  kakaoTalk,
  kandji,
  kayako,
  keap,
  kentik,
  kintone,
  klaviyo,
  knock,
  knowBe4,
  kolide,
  kronos,
  kubernetes,
  kustomer,
  lacework,
  langfuse,
  langsmith,
  lansweeper,
  lark,
  lastpass,
  lattice,
  launchDarkly,
  ldap,
  leapsome,
  learnUpon,
  lemonSqueezy,
  lever,
  lifx,
  limaCharlie,
  line,
  linear,
  linode,
  liteLlm,
  lob,
  loginCredentials,
  logScale,
  looker,
  loom,
  loops,
  luma,
  lumos,
  magento,
  mailchimp,
  make,
  malwarebytes,
  manageEngine,
  mapbox,
  marketoEngage,
  massive,
  mastodon,
  materialSecurity,
  mattermost,
  maxMind,
  medallia,
  meilisearch,
  meraki,
  mercury,
  messageBird,
  metabase,
  microsoftAzure,
  microsoftBusinessCentral,
  microsoftDefenderForEndpoint,
  microsoftFoundry,
  microsoftGraph,
  microsoftGraphDelegated,
  microsoftIntune,
  microsoftOneDrive,
  microsoftOutlook,
  microsoftSentinel,
  microsoftTeams,
  mimecast,
  miro,
  misp,
  mitre,
  mixpanel,
  modeAnalytics,
  modernTreasury,
  mollie,
  mondayDotCom,
  mongodb,
  mongodbAtlas,
  mux,
  navan,
  newsApi,
  oneSignal,
  postgres,
  mysql,
  mssql,
  mosyle,
  mural,
  mxToolBox,
  n8n,
  nagios,
  namely,
  nederlandseSpoorwegen,
  netbox,
  netlas,
  netlify,
  netskope,
  netSuite,
  newRelic,
  nextDns,
  ninjaone,
  nirvana,
  nvidiaNgc,
  notion,
  npm,
  nudgeSecurity,
  numeral,
  ocrSpace,
  octopusDeploy,
  okta,
  ollama,
  oneLogin,
  onePassword,
  onePasswordConnectServer,
  onePasswordUsers,
  onetimeSecret,
  oneTrust,
  onyphe,
  oomnitza,
  opal,
  openai,
  openaiCompatible,
  opencage,
  openHab,
  openCti,
  openRouter,
  opsGenie,
  oracleCloudHcm,
  oracleIam,
  oracleJdEdwards,
  oracleOci,
  oraclePeopleSoft,
  orcaSecurity,
  outline,
  outreach,
  paddle,
  pagerDuty,
  paloAltoPanOs,
  pandaDoc,
  panOs,
  panther,
  panWildfire,
  parallel,
  particle,
  paychex,
  paycom,
  paycor,
  paylocity,
  pdfCo,
  pdfGenerator,
  pendo,
  pentera,
  personio,
  pinecone,
  pingIdentity,
  pipedrive,
  plaid,
  plain,
  planetscale,
  planhat,
  plausible,
  pleo,
  podium,
  portainer,
  postHog,
  postman,
  postmark,
  powerBi,
  prefect,
  printful,
  prismaCloud,
  procore,
  productboard,
  productiv,
  projectDiscovery,
  prometheus,
  proofpoint,
  proofpointProtectionServer,
  proofpointThreatResponse,
  prtg,
  pulsedive,
  pulumi,
  pylon,
  qlik,
  qualtrics,
  qualys,
  quickbase,
  quickbooks,
  quickChart,
  railDataMarketplace,
  railway,
  ramp,
  rapid7,
  rawg,
  razorpay,
  recharge,
  recordedFuture,
  redisCloud,
  redmine,
  reftab,
  regscale,
  remoteMcp,
  render,
  replicate,
  resend,
  retool,
  ringCentral,
  rippling,
  rollbar,
  rootly,
  rudderStack,
  rundeck,
  runZero,
  sage,
  sailPoint,
  salesforce,
  salesloft,
  sanity,
  sapConcur,
  sapSuccessFactors,
  scaleway,
  screenshotMachine,
  secretServer,
  secureAnnex,
  secureframe,
  securityScorecard,
  securityTrails,
  segment,
  semaphore,
  semgrep,
  sendGrid,
  sentinelOne,
  sentry,
  serpApi,
  serviceNow,
  sharePoint,
  shelly,
  shippo,
  shipstationV2,
  shodan,
  shopify,
  shortcut,
  signnow,
  sisense,
  site24x7,
  slab,
  slack,
  slashid,
  smartsheet,
  smartThings,
  smtp,
  smugmug,
  snapchat,
  sncf,
  snipeIt,
  snowflake,
  snyk,
  socket,
  solarWinds,
  solarWindsServiceDesk,
  sonarCloud,
  sonarQube,
  sophos,
  sophosUtm,
  spacelift,
  sparkPost,
  split,
  splitwise,
  splunk,
  spotify,
  spur,
  spyCloud,
  square,
  squareup,
  sslMate,
  stabilityAi,
  stackexchange,
  stairwell,
  statsig,
  statuspage,
  stitchData,
  strava,
  stripe,
  sublimeSecurity,
  sugarCrm,
  sumoLogic,
  supabase,
  swaggerHub,
  swedavia,
  symantecEndpointSecurity,
  synack,
  sysAid,
  sysdig,
  tableau,
  tailscale,
  tally,
  tapfiliate,
  tanium,
  tavily,
  taxjar,
  teamcity,
  teamCymruScout,
  teamwork,
  telegram,
  telnyx,
  tenable,
  terraformCloud,
  theHive,
  thinkstCanary,
  threatconnect,
  threeB,
  threeCx,
  ticktick,
  timely,
  tines,
  tipalti,
  todoist,
  togetherAi,
  traceableAi,
  transcend,
  transportForIreland,
  transportForLondon,
  travelPerk,
  travisCi,
  traxo,
  trellix,
  trello,
  tremendous,
  trendMicro,
  trendVisionOne,
  twilio,
  twitch,
  typeform,
  uber,
  ukg,
  ultimateSoftware,
  unpacme,
  unsplash,
  upcloud,
  upguard,
  upstash,
  uptycs,
  upwind,
  urlscan,
  vanta,
  varonis,
  vectraAi,
  veeam,
  venafi,
  vercel,
  veza,
  vimeo,
  virusTotal,
  vmray,
  vonage,
  voyageAi,
  vulncheck,
  vultr,
  waveAccounting,
  wazuh,
  weaviate,
  webex,
  webflow,
  webinarjam,
  weightsAndBiases,
  whoisFreaks,
  whoop,
  wigle,
  wiz,
  woocommerce,
  workable,
  workday,
  workRamp,
  wufoo,
  wrike,
  xbow,
  xero,
  yahoo,
  yelp,
  zabbix,
  zendesk,
  zendeskSell,
  zenefits,
  zeplin,
  zohoCrm,
  zohoDesk,
  zoom,
  zoomInfo,
  zscaler,
  zulip,
  zuora,
  workflowApp,
  capeSandbox,
  castle,
  dnsFilter,
  dockerRegistry,
  facebookMessenger,
  firebase,
  googleAdminConsole,
  hatchingTriage,
  humio,
  ibmXForceExchange,
  idMe,
  kibana,
  linkedIn,
  logPoint,
  logzIo,
  lucidChart,
  malShare,
  mend,
  netography,
  nutanixPrism,
  pastebin,
  phishStats,
  plexTrac,
  phylum,
  pushover,
  silentPush,
  sonatype,
  threatExchange,
  vmwareVSphere,
  vuldb,
  workplace,
  x,
  xMatters,
  bookStack,
  gotify,
  healthchecks,
  immich,
  jellyfin,
  keycloak,
  nextcloud,
  proxmox,
  sonarr,
  vikunja,
  chatwoot,
  clickhouse,
  confluent,
  crowdin,
  deepl,
  deepseek,
  directus,
  discourse,
  dnsimple,
  everhour,
  fastmail,
  forgejo,
  freshbooks,
  gitbook,
  godaddy,
  grist,
  hetzner,
  influxdb,
  kestra,
  listmonk,
  mailgun,
  mailjet,
  matomo,
  mistralAi,
  namecheap,
  neonTech,
  nocodb,
  nuclino,
  odoo,
  openproject,
  opensearch,
  paypal,
  pocketbase,
  rancher,
  reddit,
  sourcegraph,
  squidex,
  strapi,
  surveymonkey,
  taiga,
  toggl,
  typesense,
  uptimerobot,
  wakatime,
  wise,
  windmill,
  woodpeckerCi,
  wordpress,
  yourls,
  ynab,
  zammad,
  zeroFox,
  zitadel,
  action1,
  activepieces,
  apacheAirflow,
  budibase,
  buildium,
  chroma,
  coder,
  couchDb,
  dependencyTrack,
  documenso,
  dub,
  elevenLabs,
  esetProtect,
  espoCrm,
  flowise,
  formbricks,
  fusionAuth,
  glpi,
  grok,
  hasura,
  hashicorpConsul,
  hashicorpNomad,
  huggingFace,
  infisical,
  invoiceNinja,
  kimai,
  logto,
  matrixSynapse,
  mautic,
  medusaJs,
  neo4j,
  netdata,
  oneuptime,
  paperlessNgx,
  payloadCms,
  penpot,
  pingdom,
  plane,
  qdrant,
  rabbitmq,
  rocketChat,
  signoz,
  squarespace,
  teamtailor,
  tolgee,
  tooljet,
  topdesk,
  twingate,
  umami,
  upwork,
  zapier,
  audiobookshelf,
  bitwarden,
  bluesky,
  changedetection,
  contabo,
  dagster,
  deezer,
  freshRss,
  googleAnalytics,
  googleSearchConsole,
  gotosocial,
  govee,
  habitica,
  headscale,
  instagram,
  ionos,
  kavita,
  komga,
  leantime,
  lemmy,
  linkding,
  mealie,
  medium,
  miniflux,
  minio,
  misskey,
  modrinth,
  navidrome,
  netbird,
  ntfy,
  opnsense,
  ovh,
  patreon,
  peertube,
  perplexity,
  pinterest,
  pixelfed,
  planka,
  plex,
  seafile,
  shlink,
  sourcehut,
  steam,
  syncthing,
  tandoorRecipes,
  tiktok,
  tumblr,
  wallabag,
  whatsapp,
  wikijs,
  youtube,
  actionNetwork,
  acuityScheduling,
  adalo,
  airtop,
  apiTemplateIo,
  autopilot,
  brandfetch,
  bubble,
  clearbit,
  cockpit,
  harvest,
  highLevel,
  humanticAi,
  impervaWaf,
  jotForm,
  koBoToolbox,
  lemlist,
  loneScale,
  mailcheck,
  mailerLite,
  marketstack,
  mindee,
  msg91,
  demio,
  dfirIris,
  dhl,
  disqus,
  dropcontact,
  egoi,
  emelia,
  erpNext,
  eventbrite,
  filescan,
  flow,
  formstack,
  ghost,
  netscalerAdc,
  oneSimpleApi,
  onfleet,
  openWeatherMap,
  orbit,
  oura,
  plivo,
  profitWell,
  seaTable,
  sekoia,
  shuffler,
  sms77,
  storyblok,
] as const;

export const connectorDefinitions: readonly ConnectorDefinition[] =
  connectorTypes.flatMap((type) => type.variants);

export const connectorsByIdentifier = connectorDefinitions.reduce(
  (acc, definition) => {
    acc[definition.identifier] = definition;
    return acc;
  },
  {} as Record<string, ConnectorDefinition>
);

export function resolveConnectorDefinition(
  identifier: string | null | undefined
): ConnectorDefinition | undefined {
  if (!identifier) return undefined;
  return (
    connectorsByIdentifier[identifier] ??
    connectorDefinitions.find(
      (definition) =>
        identifier.endsWith(`-${definition.identifier}`) ||
        identifier.endsWith(`_${definition.identifier}`)
    )
  );
}

const typeByIdentifier = new Map<string, ConnectorType>(
  connectorTypes.flatMap((type) =>
    type.variants.map((variant) => [variant.identifier, type as ConnectorType])
  )
);

export function connectorTypeOf(identifier: string): ConnectorType | undefined {
  return typeByIdentifier.get(identifier);
}
